import { brandColorTokens, brandRadius } from "@constants";
import { navigationItemDimensions } from "./NavigationList.constants";

const { height, verticalSpacing, horizontalInset } = navigationItemDimensions;

export const getActiveIndicatorStyle = (activeIndex: number) => ({
  position: "absolute",
  top: 0,
  left: horizontalInset,
  right: horizontalInset,
  height,
  borderRadius: `${brandRadius.medium}px`,
  bgcolor: "background.default",
  pointerEvents: "none",
  transform: `translateY(${activeIndex * (height + verticalSpacing * 2) + verticalSpacing}px)`,
  transition: "transform 350ms cubic-bezier(0.2, 0, 0, 1)",
  "@media (prefers-reduced-motion: reduce)": { transition: "none" },
  "&::before": {
    content: '""',
    position: "absolute",
    left: 4,
    top: "25%",
    height: "50%",
    width: 3,
    borderRadius: `${brandRadius.small}px`,
    bgcolor: brandColorTokens.text.display,
  },
});
